import axios from 'axios';
import { setAlert } from './alert';
import {
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    USER_LOADED,
    AUTH_USER_ERROR,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAIL,
    LOGOUT_USER,
    CLEAR_USER_PROFILE
} from './types';
import setAuthToken from '../utils/setAuthToken';
import {URL} from './url'
// Load User
export const loadUser = () => async dispatch => {
    if(localStorage.token) {
        setAuthToken(localStorage.token);
    }

    try {
        const res = await axios.get(`${URL}/api/authUser`);

        dispatch({
            type: USER_LOADED,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: AUTH_USER_ERROR
        });
    }
};

// Register User
export const register = ({ name, email, password }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ name, email, password });
    try {
        const res = await axios.post(`${URL}/api/users`, body, config);

        dispatch({
            type: REGISTER_USER_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());
    } catch (err) {
        const errors = err.response.data.errors;
        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({
            type: REGISTER_USER_FAIL
        });
    }
};

// Login User
export const login = (email, password) => async (dispatch) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ email, password });
    try {
        const res = await axios.post(`${URL}/api/authUser`, body, config);

        dispatch({
            type: LOGIN_USER_SUCCESS,
            payload: res.data
        });
        dispatch(loadUser());
    } catch (err) {
        const errors = err.response.data.errors;
        if(errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }

        dispatch({ 
            type: LOGIN_USER_FAIL
        });
    }
};

// Logout/ clear Profile
export const logout_user = () => dispatch => {
    dispatch({
        type: CLEAR_USER_PROFILE
    });
    dispatch({
        type: LOGOUT_USER
    });
}